/**
 * A régua de "este backup existe" (#805).
 *
 * Um backup bem-sucedido não tem um estado, tem TRÊS: `completed` (feito),
 * `verifying` (verificação em curso) e `verified` (verificação concluída).
 * Desde que a verificação passou a ser disparada na conclusão, todo backup de
 * job ou schedule com `verification_enabled` atravessa `verifying` logo depois
 * de terminar e TERMINA em `verified` — que é estado permanente, não janela.
 *
 * Contar só `completed`, ou o par `completed`/`verified`, faz o backup sumir da
 * tela: foi assim que o indicador de última execução do job passou a mostrar
 * relógio cinza para backups que deram certo, e que o botão de restaurar
 * desaparecia enquanto a verificação rodava.
 *
 * Espelha `BACKUP_CONCLUIDO_STATUSES` de `backend/app/models/backup.py`.
 */
export const BACKUP_CONCLUIDO_STATUSES = ['completed', 'verifying', 'verified']

export const isBackupConcluido = (status: string): boolean =>
  BACKUP_CONCLUIDO_STATUSES.includes(status)

/**
 * Valor a mandar em `?status=` para pedir "os backups que existem".
 *
 * O filtro do servidor compara `status` de forma EXATA, então mandar
 * `completed` esconderia os backups que já foram verificados — a maioria, desde
 * que a verificação é automática. Espelha `FILTRO_DE_BACKUP_CONCLUIDO` de
 * `backend/app/api/v1/backups.py`.
 */
export const FILTRO_DE_BACKUP_CONCLUIDO = 'concluido'
